import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from '@/functions/Util';
export default class RegiaoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let regiao = model;

        if (Util.isNull(regiao.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(regiao.idregiaoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if ((regiao.reajustecif > 100 || regiao.reajustecif < -100) || (regiao.reajustefob > 100 || regiao.reajustefob < -100)) {
            this.showMessage(new Message('alert', 'porcentagem-invalida', true));
            return false;
        }

        if (!validated) {
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }

}